import {BaseService} from './baseService.js';

/* 
 * Handles interaction with the security apis
 */
export class ReportService extends BaseService {
	
	constructor() {	
		super();		
	}
	
	//Report Definitions
	
	async getReportDefinitions(companyId, groupId) {	
		var params = '?';
		if (companyId) {
			params += '&companyId=' + companyId;
		}
		if (groupId) {
			params += '&groupId=' + groupId;
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions' + params);		
		return data;
	}
	
	async getCompanyReports() {		
		var data = await this.makeGETRequest('/api/resource/report-definitions/company-reports');		
		return data;
	}
	
	async getUserReports() {		
		var data = await this.makeGETRequest('/api/resource/report-definitions/user-reports');		
		return data;
	}

	async getVisibilityReports(visibilityType) {
		var params = '';
		if (visibilityType) {
			params = '?visibilityType=' + encodeURIComponent(visibilityType);
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions/visibility-reports' + params);
		return data;
	}

	async saveVisibilityOverride(reportType, visibilityType) {
		var saved = await this.makePUTRequest(
			'/api/resource/report-definitions/visibility-override/' + encodeURIComponent(reportType),
			{ visibilityType: visibilityType }
		);
		return saved;
	}

	async clearVisibilityOverride(reportType) {
		var data = await this.makeDELETERequest(
			'/api/resource/report-definitions/visibility-override/' + encodeURIComponent(reportType)
		);
		return data;
	}
	
	async getCompanyReportsCompanies(reportType) {		
		var data = await this.makeGETRequest('/api/resource/report-definitions/company-reports/' + reportType + '/companies');		
		return data;
	}
	
	async getUseReportUsers(reportType) {		
		var data = await this.makeGETRequest('/api/resource/report-definitions/user-reports/' + reportType + '/users');		
		return data;
	}
	
	async deleteCompanyFromReport(reportType, companyId) {		
		var data = await this.makeDELETERequest('/api/resource/report-definitions/company-reports/' + reportType + '/' + companyId);		
		return data;
	}
	
	async deleteUserFromReport(reportType, username) {		
		var data = await this.makeDELETERequest('/api/resource/report-definitions/user-reports/' + reportType + '/' + username);		
		return data;
	}	
	
	async addCompanyToReport(reportType, companyId) {
		var saved = await this.makePOSTRequest('/api/resource/report-definitions/company-reports/' + reportType + '/' + companyId, {});
		return saved;
	}
	
	async addUserToReport(reportType, username) {
		var saved = await this.makePOSTRequest('/api/resource/report-definitions/user-reports/' + reportType + '/' + username, {});
		return saved;
	}	
	
	async getUnitGroupOption(companyId) {	
		var params = '';
		if (companyId) {
			params = '?companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/unit-groups' + params);		
		return data;
	}

	async getUnitGroupEmail(companyId, unitGroupId) {
		var params = '?';
		if (companyId) {
			params += 'companyId=' + companyId;
		}
		if (unitGroupId) {
			params += '&unitGroupId=' + unitGroupId;
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/unit-group-email' + params);
		return data;
	}
	
	async getMPGOverrides(companyId, unitGroupId) {	
		var params = '?';
		if (companyId) {
			params += 'companyId=' + companyId;						
		}
		if (unitGroupId) {
			params += '&unitGroupId=' + companyId;						
		}		
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/mpg-overrides' + params);		
		return data;
	}
	
	async getFueltaxPreference(companyId, unitGroupId) {
		var params = '?';
		if (companyId) {
			params += 'companyId=' + companyId;						
		}
		if (unitGroupId) {
			params += '&unitGroupId=' + companyId;						
		}			
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/fueltax-preference' + params);		
		return data;
	}
	
	async getYearMonthQuarter(calendarYears) {		
		var params = '';
		if (calendarYears) {
			params = '?yearSet=CALENDAR';
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/year-month-quarters' + params);		
		return data;
	}	
	
	async getDataFilters(companyId, dataType) {	
		var params = '';
		if (companyId) {
			params = '?companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/report-definitions/options/data-filters/' + dataType + '/' + params);		
		return data;
	}	
	
	//Report History

	buildReportHistoryQueryString(paging, companyId) {
		var queryParts = [];
		if (paging) {
			var pagingParams = this.toQueryParam(paging);
			if (pagingParams) {
				queryParts.push(pagingParams);
			}
		}
		if (companyId) {
			queryParts.push('companyId=' + encodeURIComponent(companyId));
		}
		if (queryParts.length === 0) {
			return '';
		}
		return '?' + queryParts.join('&');
	}
	
	async getReports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/reports' + params);		
		return data;
	}

	exportReports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/reports/export' + params);
	}
	
	async getReportUnits(reportId, paging, companyId) {
		var params = this.buildReportHistoryQueryString(paging, companyId);
		var data = await this.makeGETRequest('/api/resource/reports/' + reportId + '/units' + params);		
		return data;
	}

	exportReportUnits(reportId, paging, companyId) {
		var params = this.buildReportHistoryQueryString(paging, companyId);
		this.downloadFile('/api/resource/reports/' + reportId + '/units/export' + params);
	}

	async getReportBulkGroups(reportId, paging, companyId) {
		var params = this.buildReportHistoryQueryString(paging, companyId);
		var data = await this.makeGETRequest('/api/resource/reports/' + reportId + '/bulk-groups' + params);
		return data;
	}

	exportReportBulkGroups(reportId, paging, companyId) {
		var params = this.buildReportHistoryQueryString(paging, companyId);
		this.downloadFile('/api/resource/reports/' + reportId + '/bulk-groups/export' + params);
	}
	
	async getReportDetails(reportId, companyId) {
		var params = this.buildReportHistoryQueryString(null, companyId);
		var data = await this.makeGETRequest('/api/resource/reports/' + reportId + '/details' + params);		
		return data;
	}
	
	downloadReport(reportId, outputId, companyId) {
		var queryParts = [];
		if (outputId) {
			queryParts.push('outputId=' + encodeURIComponent(outputId));
		}
		if (companyId) {
			queryParts.push('companyId=' + encodeURIComponent(companyId));
		}
		var query = queryParts.length ? '?' + queryParts.join('&') : '';
		this.downloadFile('/api/resource/reports/' + reportId + query);
	}
	
	async deleteReport(reportId, companyId) {
		var params = this.buildReportHistoryQueryString(null, companyId);
		var data = await this.makeDELETERequest('/api/resource/reports/' + reportId + params);		
		return data;
	}
	
	async submitReport(reportSubmission) {
		var saved = await this.makePOSTRequest('/api/resource/reports', reportSubmission);
		return saved;
	}	
	
	//Sheduled	
	async getScheduledReports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/scheduled-reports' + params);		
		return data;
	}
	
	async getScheduledReportUnits(reportId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/scheduled-reports/' + reportId + '/units' + params);		
		return data;
	}

	async getScheduledReportBulkGroups(reportId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/scheduled-reports/' + reportId + '/bulk-groups' + params);
		return data;
	}	
	
	async deleteScheduledReport(scheduledReportId) {
		var data = await this.makeDELETERequest('/api/resource/scheduled-reports/' + scheduledReportId);		
		return data;
	}
	
	async activateReport(scheduledReportId) {
		var data = await this.makePUTRequest('/api/resource/scheduled-reports/' + scheduledReportId + '/activate');		
		return data;
	}		
	
	async inactivateReport(scheduledReportId) {
		var data = await this.makePUTRequest('/api/resource/scheduled-reports/' + scheduledReportId + '/inactivate');		
		return data;
	}		
	
	async saveScheduleReport(scheduledReport, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/scheduled-reports/' + scheduledReport.scheduleReportId, scheduledReport);
		} else {
			saved = await this.makePOSTRequest('/api/resource/scheduled-reports', scheduledReport);
		}
		return saved;
	}
	
	async validateCron(checkExpression) {
		var validationData = await this.makePOSTRequest('/api/service/application/validate-cron', checkExpression);
		return validationData;
	}	
	
	//closed reports
	async getCloseReports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/close-reports' + params);		
		return data;
	}	
	
	async saveCloseReport(closeReportSet, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/close-reports/' + closeReportSet.closeReportSetId, closeReportSet);
		} else {
			saved = await this.makePOSTRequest('/api/resource/close-reports', closeReportSet);
		}
		return saved;
	}
	
	async activateCloseReport(closeReportSetId) {
		var data = await this.makePUTRequest('/api/resource/close-reports/' + closeReportSetId + '/activate');		
		return data;
	}		
	
	async inactivateCloseReport(closeReportSetId) {
		var data = await this.makePUTRequest('/api/resource/close-reports/' + closeReportSetId + '/inactivate');		
		return data;
	}
	
	async addReportCloseReportSet(closeReportSetId, submissionModel) {
		var saved = await this.makePOSTRequest('/api/resource/close-reports/' + closeReportSetId + '/reports', submissionModel);		
		return saved;
	}	
		
	async getCloseSetReports(closeReportSetId) {
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/reports');		
		return data;
	}	
	
	async getCloseSetReportTemplate(closeReportSetId, closeReportDetailId) {
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/reports/' + closeReportDetailId + '/template');		
		return data;
	}		
	
	async deleteCloseSetReportTemplate(closeReportSetId, closeReportDetailId) {
		var data = await this.makeDELETERequest('/api/resource/close-reports/' + closeReportSetId + '/reports/' + closeReportDetailId);		
		return data;
	}	
	
	async getCloseReportRuns(closeReportSetId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/runs' + params);		
		return data;
	}	
	
	async getCloseReportRunDetail(closeReportSetId, runHistoryId) {
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/runs/' + runHistoryId);		
		return data;
	}
	
	async createNewRun(closeReportSetId, runModel) {
		var data = await this.makePOSTRequest('/api/resource/close-reports/' + closeReportSetId + '/runs', runModel);		
		return data;
	}	
	
	async toggleAttachCloseReport(closeReportSetId, closeReportDetailId) {
		var data = await this.makePUTRequest('/api/resource/close-reports/' + closeReportSetId + '/reports/' + closeReportDetailId + '/toggle-attach');		
		return data;
	}	
	
	async getCloseReportUnits(closeReportSetId, closeReportDetailId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/reports/' + closeReportDetailId + '/units' + params);		
		return data;
	}

	async getCloseReportBulkGroups(closeReportSetId, closeReportDetailId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/reports/' + closeReportDetailId + '/bulk-groups' + params);
		return data;
	}		
	
	downloadCloseReport(closeReportSetId, runHistoryId, reportHistoryId) {			
		this.downloadFile('/api/resource/close-reports/' + closeReportSetId + '/runs/' + runHistoryId + '/details/' + reportHistoryId + '/download');	
	}
	
	async getReportDetailOnRun(closeReportSetId, runHistoryId, reportHistoryId) {
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/runs/' + runHistoryId + '/details/' + reportHistoryId + '/detail');	
		return data;
	}	
	
	async getReportDetailOnRunUnits(closeReportSetId, runHistoryId, reportHistoryId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/runs/' + runHistoryId + '/details/' + reportHistoryId + '/units' + params);	
		return data;
	}

	async getReportDetailOnRunBulkGroups(closeReportSetId, runHistoryId, reportHistoryId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/close-reports/' + closeReportSetId + '/runs/' + runHistoryId + '/details/' + reportHistoryId + '/bulk-groups' + params);
		return data;
	}	
	
	//Report Templates	
	async getTemplateReports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/custom-report-templates' + params);		
		return data;
	}
	
	async getTemplateAvailableProducts() {			
		var data = await this.makeGETRequest('/api/resource/custom-report-templates/available-products');		
		return data;
	}
	
	async getTemplateAvailableReportTypes() {
		var data = await this.makeGETRequest('/api/resource/custom-report-templates/available-report-types');	
		return data;
	}	
	
	async saveTemplateReport(templateReport, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/custom-report-templates/' + templateReport.templateId, templateReport);
		} else {
			saved = await this.makePOSTRequest('/api/resource/custom-report-templates', templateReport);
		}
		return saved;
	}	
	
	downloadTemplateReport(templateId) {			
		this.downloadFile('/api/resource/custom-report-templates/download/' + templateId);		
	}	

	async deleteTemplateReport(templateId) {
		var data = await this.makeDELETERequest('/api/resource/custom-report-templates/' + templateId);		
		return data;
	}		
	
	async activateTemplateReport(templateId) {	
		var result = await this.makePUTRequest('/api/resource/custom-report-templates/' + templateId + '/activate');
		return result;
	}	

	async inactivateTemplateReport(templateId) {	
		var result = await this.makePUTRequest('/api/resource/custom-report-templates/' + templateId + '/inactivate');
		return result;
	}

}

